<template>
	<div id="Zmyy" style="margin-top:-20px;">

		<div class="g-right-middle width800">
			<div class="g-ypxx">
				<div  v-for="(item,index) in list" class="addmore-line">
				<p>
					<span class="ypxx-left">角色名称</span>
					<span class="ypxx-right"><input v-model="list[index].role_name" type="text" placeholder="请输入角色名称"></span>
          <span class="el-icon-minus" @click="DelList(index)" v-if="list.length===1?false:true" style="margin-top: 0;">删除</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">角色类型</span>
					<span class="ypxx-right">
						<RadioGroup v-model="list[index].nature">
							<Radio label="1">男演员</Radio>
							<Radio label="2">女演员</Radio>
							<Radio label="3">老人演员</Radio>
							<Radio label="4">儿童演员</Radio>
							<Radio label="5">跟组演员</Radio>
							<Radio label="6">群众演员</Radio>
							<Radio label="7">特约演员</Radio>
							<Radio label="8">特技演员</Radio>
							<Radio label="9">特型演员</Radio>
						</RadioGroup>
					</span>
					<div class=" clearfix"></div>
				</p>
				<p>
					<span class="ypxx-left">角色简介</span>
					<span class="ypxx-right">
						<textarea v-model="list[index].synopsis" class="g-wd-txt" placeholder="限300字以内"></textarea>
					</span>
					<div class=" clearfix"></div>
				</p>
				</div>
				<input class="addmore" type="button" @click="AddList" value="添加更多招募信息">
				<!-- <input type="button" @click="DelList" value="-"> -->
				<center><input @click="ypxx" type="button" class="g-btn" value="下一步"></center>
			</div>
		</div>
	</div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default {
		data() {
			return {
				uid: '',
				list: [{role_name: '',nature:'',synopsis: ''}]
			}
		},
		methods: {
			AddList() {
				this.list.push({
					role_name: '',
					nature: '',
					synopsis: ''
				})
		},
      DelList(index) {
        this.list.splice(index,1)
      },
		ypxx() {
			var api = 'http://api.yopoo.cn/api/centre/crewactor'
			var list=this.list
			let infor = {
				list:this.list,
				uid: storage.get('newuid')
			}
			Axios.post(api, infor).then((res) => {

				if (res.data.code == '200') {
					setTimeout(() => { //测试uid暂时取消跳转
						this.$message({     //提示发送验证码成功信息
							message: res.data.msg,
							type: 'success',
							center:true
						});
						this.$router.push(
							{
								path: '/group_admin/edit/infor',
							}
						) //登录后跳转页面
					}, 200);
				}
				if (res.data.code == '202') {
					this.$message({     //提示发送验证码成功信息
						message: res.data.msg,
						type: 'error',
						center:true
					});
				}
			})
		}
	},
	mounted() {

		},

	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/group_admin/edit/G_Zmyy.vue